function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.064 3.75a4.521 4.521 0 0 0 0 1.5H3.5A1.5 1.5 0 0 0 2 6.75v.244l.012.19a1.5 1.5 0 0 0 .7 1.087l7.5 4.614a1.502 1.502 0 0 0 1.575 0l6.92-4.258a4.483 4.483 0 0 0 2.793.26v8.363a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V6.75a3 3 0 0 1 3-3h12.564zm-3.49 10.413h-.002a3 3 0 0 1-1.364.438l-.208.007a3 3 0 0 1-1.573-.446L2 9.594v7.656a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5V9.593l-7.427 4.57z",
  fill: "#EA4968"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.5 2a2.5 2.5 0 0 1 .293 4.981l-.032.005a2.5 2.5 0 0 1-2.74-2.179c-.004-.028-.008-.056-.01-.084a2.52 2.52 0 0 1 0-.447c.002-.028.006-.056.01-.085a2.527 2.527 0 0 1 .078-.382A2.5 2.5 0 0 1 20.5 2z",
  fill: "#EA4968"
});

const SvgEnvelopeUnread = props => React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none"
}, props), _ref, _ref2);

export default SvgEnvelopeUnread;